/**
 * Shared so the reset link shef-api emails and the route shef-web serves it on cannot drift — on
 * either brand's host.
 */
export const RESET_PASSWORD_PATH_SEGMENT = 'reset-password';

export const resetPasswordPath = (resetToken: string): string => `/${RESET_PASSWORD_PATH_SEGMENT}/${resetToken}`;
